import { render } from "./PlotOptions.vue?vue&type=template&id=36b2ce12"
import script from "./PlotOptions.vue?vue&type=script&lang=js"
export * from "./PlotOptions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__